<!-- 
	This is the dashboard page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
    <div>
        <div v-if="initData">
            <!-- Counter Widgets -->
            <div class="counter_list">
                <div class="mb-24 counter_item" v-for="(stat, index) in stats" :key="index">
                    <!-- Widget 1 Card -->
                    <WidgetCounter
                        :title="stat.title"
                        :value="stat.value"
                        :prefix="stat.prefix"
                        :suffix="stat.suffix"
                        :icon="stat.icon"
                        :status="stat.status"
                        :url="stat.url"
                    ></WidgetCounter>
                    <!-- / Widget 1 Card -->
                </div>
            </div>
            <!-- / Counter Widgets -->

            <!-- Cards -->
            <a-row :gutter="24" type="flex" align="stretch">
                <a-col :span="24" :xl="14" class="mb-24">

                    <!-- Information Card 1 -->
                    <CardInfo :store-addr="storeAddr"></CardInfo>
                    <!-- / Information Card 1 -->

                </a-col>
                <a-col :span="24" :xl="10" class="mb-24">

                    <!-- Information Card 2 -->
                    <CardInfo2></CardInfo2>
                    <!-- / Information Card 2 -->
                </a-col>
            </a-row>
            <!-- / Cards -->

            

            <!-- Table & Timeline -->
            <a-row :gutter="24" type="flex" align="stretch">
                <!-- Table -->
                <a-col :span="24" :lg="12" class="mb-24">
                    
                    <!-- Projects Table Card -->
                    <CardProjectTable
                        key="inStore"
                        :title="$t('info_14')"
                        :description="$t('info_15')"
                        :data-count="count"
                        :data="tableData"
                        :columns="tableColumns"
                        :loading="loading"
                        @change="onChangeInStore"
                    ></CardProjectTable>
                    <!-- / Projects Table Card -->
                </a-col>
                <!-- / Table -->

                <!-- Timeline -->
                <a-col :span="24" :lg="12" class="mb-24">
                    <!-- Orders History Timeline Card -->
                    <CardProjectTable
                        key="outStore"
                        :title="$t('info_16')"
                        :description="$t('info_17')"
                        :data-count="count2"
                        :data="tableData2"
                        :columns="tableColumns2"
                        :loading="loading2"
                        @change="onChangeOutStore"
                    ></CardProjectTable>
                    <!-- / Orders History Timeline Card -->

                </a-col>
                <!-- / Timeline -->
            </a-row>
            <!-- / Table & Timeline -->
        </div>
        <div class="page_loading" v-else><a-spin></a-spin></div>
    </div>
</template>

<script>

	// Counter Widgets
	import WidgetCounter from '@/components/Widgets/WidgetCounter' ;

	// "Projects" table component.
	import CardProjectTable from '@/components/Cards/CardProjectTable' ;

	// Information card 1.
	import CardInfo from '@/components/Cards/CardInfo' ;

	// Information card 2.
	import CardInfo2 from '@/components/Cards/CardInfo2' ;



	export default ({
		components: {
			WidgetCounter,
			CardProjectTable,
			CardInfo,
			CardInfo2,
		},
		data() {
			return {
                tableColumns: [
                    {
                        title: this.$t('info_6'),
                        dataIndex: 'source_waybill_no',
                        key: 'source_waybill_no',
                        scopedSlots: { customRender: 'source_waybill_no' },
                        width: 180
                    },
                    {
                        title: this.$t('info_7'),
                        scopedSlots: { customRender: 'pkg_items' },
                    },
                    {
                        title: this.$t('info_8'),
                        key: 'weight_volume',
                        scopedSlots: { customRender: 'weight_volume' },
                    },
                    {
                        title: this.$t('info_9'),
                        dataIndex: 'ptime',
                        key: 'ptime'
                    },
                    {
                        title: this.$t('info_10'),
                        scopedSlots: { customRender: 'operation1' },
                    }
                ],
				tableData : [],
                page: 1,
                count: 0,
                loading: false,

                tableColumns2: [
                    {
                        title: this.$t('info_6'),
                        dataIndex: 'trans_num',
                        key: 'trans_num',
                        scopedSlots: { customRender: 'trans_num' },
                        width: 200
                    },
                    {
                        title: this.$t('info_11'),
                        dataIndex: 'statusStr',
                        key: 'statusStr',
                        scopedSlots: { customRender: 'status' },
                    },
                    {
                        title: this.$t('info_12'),
                        dataIndex: 'ctime',
                        key: 'ctime'
                    },
                    {
                        title: this.$t('info_10'),
                        scopedSlots: { customRender: 'operation2' },
                    }
                ],
                tableData2 : [],
                page2: 1,
                count2: 0,
                loading2: false,



                // Counter Widgets stats
                stats: [
                    {
                        title: this.$t('info_1'),
                        value: 0,
                        prefix: "",
                        suffix: "",
                        url: '/user/create_shipment?status=3',
                        icon: `
                            <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z" fill="#111827"/>
                                <path d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z" fill="#111827"/>
                                <path d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z" fill="#111827"/>
                            </svg>`,
                    },
                    {
                        title: this.$t('info_2'),
                        value: 0,
                        suffix: "",
                        url: '',
                        icon: `
                            <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z" fill="#111827"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z" fill="#111827"/>
                            </svg>`,
                    },
                    {
                        title: this.$t('info_3'),
                        value: 0,
                        prefix: "",
                        status: "",
                        suffix: "",
                        url: '/user/order?status=1',
                        icon: `
                            <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z" fill="#111827"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z" fill="#111827"/>
                            </svg>`,
                    },
                    {
                        title: this.$t('info_4'),
                        value: 0,
                        prefix: "$",
                        suffix: "",
                        url: '/user/member_balance',
                        icon: `
                            <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z" fill="#111827"/>
                                <path d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z" fill="#111827"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z" fill="#111827"/>
                            </svg>`,
                    },
                    {
                        title: this.$t('info_5'),
                        value: 0,
                        prefix: "",
                        suffix: "",
                        url: '/user/create_shipment',
                        icon: `
                            <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z" fill="#000000"/>
                            </svg>`,
                    },
                ],

                initData: '',

                storeAddr: '',
			}
		},

        created() {
            this.onInitData();
            this.onGetInStore();
            this.onGetOutStore();
        },

        methods: {
            onInitData() {
                this.$HTTP.post('/member/Member/index').then(({data}) => {
                    if(data.sts == 1) {
                        let {in_package, dck_order, dfk_order, balance, all_package} = data.data;

                        this.stats[0].value = in_package;
                        this.stats[1].value = dck_order;
                        this.stats[2].value = dfk_order;
                        this.stats[3].value = balance;
                        this.stats[4].value = all_package;

                        this.initData = data.data;
                        this.storeAddr = data.data.store_addr[0];
                        
                    }
                })
            },

            // 获取在仓包裹列表
            onGetInStore() {
                let params = {
                    status: '3',
                    is_shelf: '',
                    type: '',
                    limit: 18,
                    msearch: 1,
                    save_search_name: '',
                    page: 1,
                }
                this.loading = true;
                this.$HTTP.get('/package/package_forecast/columns/coldata',{params}).then(({data}) => {
                    this.loading = false;
                    if(data.sts == 1) {
                        this.count = data.count;
                        this.tableData = data.data;
                        this.tableData.forEach((item) => {
                            item.ptime = item.ptime.split(' ')[0];
                        });
                    }
                })
            },

            onChangeInStore(page) {
                this.page = page;
                this.onGetInStore();
            },

            // 获取在仓包裹列表
            onGetOutStore() {
                let params = {
                    page: 1,
                    limit: 18,
                    status: 'status',
                    f: 3,
                    l: 11,
                }
                this.loading2 = true;
                this.$HTTP.get('/order/order_package/slist',{params}).then(({data}) => {
                    this.loading2 = false;
                    if(data.sts == 1) {
                        this.count2 = data.data.count;
                        this.tableData2 = data.data.list;
                        this.tableData2.forEach((item) => {
                            item.ctime = item.ctime.split(' ')[0];
                        });
                    }
                })
            },

            onChangeOutStore(page) {
                this.page2 = page;
                this.onGetOutStore();
            }
        }
	})

</script>

<style lang="scss">
    .counter_list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        .counter_item {
            flex: none;
            width: calc(100% / 5 - 20px);
            cursor: pointer;
            &:hover {
                .widget-1.ant-card {
                    background-color: #0565a9;
                    .icon {
                        background: #fff;
                        color: #0565a9;
                        svg {
                            path {
                                fill: #0565a9;
                            }
                        }
                    }

                    .ant-statistic-title {
                        color: #fff;
                    }
                    .ant-statistic-content-prefix {
                        color: #fff;
                    }
                    .ant-statistic-content-value {
                        color: #fff;
                    }
                }
            }
        }
    }

    @media (max-width: 1200px) {
        .counter_list {
            .counter_item {
                width: calc(100% / 2 - 20px);
            }
        }
    }

    @media (max-width: 992px) {
        .counter_list {
            .counter_item {
                width: 100%;
            }
        }
    }
    .page_loading {
        text-align: center;
        padding: 100px 0 0;
    }

    
</style>